// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ---------- Full-screen overlay ---------- */
.ad-overlay {
  position: fixed;
  inset: 0;
  z-index: 5000;
  background: radial-gradient(ellipse at center, rgba(14, 59, 46, 0.85), rgba(4, 16, 12, 0.95));
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  animation: ad-fade-in 0.4s ease;
  overflow: hidden;
}
@keyframes ad-fade-in { from { opacity: 0; } to { opacity: 1; } }

/* ---------- ✨ Sparkle layers (background + image) ---------- */
.ad-sparkles { position: absolute; inset: 0; pointer-events: none; z-index: 1; }
.ad-box .ad-sparkles { z-index: 3; }   /* layer above the image inside the box */

.sparkle {
  position: absolute;
  background: #fff;
  clip-path: polygon(50% 0%, 61% 35%, 98% 36%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 36%, 39% 35%);
  opacity: 0;
  filter: drop-shadow(0 0 10px rgba(255, 255, 255, 1));   /* 👈 stronger glow */
  animation: ad-twinkle ease-in-out infinite;
}
.sparkle.gold {
  background: var(--gold-light);
  filter: drop-shadow(0 0 12px rgba(230, 205, 143, 1));
}

@keyframes ad-twinkle {
  0%   { opacity: 0; transform: scale(0.2) rotate(0deg); }
  50%  { opacity: 1; transform: scale(1.15) rotate(90deg); }   /* 👈 brighter peak */
  100% { opacity: 0; transform: scale(0.2) rotate(180deg); }
}

/* ---------- Ad box (above background sparkles) ---------- */
.ad-box {
  position: relative;
  z-index: 2;
  width: min(760px, 94%);
  max-height: 92vh;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 30px 90px rgba(0, 0, 0, 0.6), 0 0 60px rgba(201, 162, 75, 0.25);
  animation: ad-pop-in 0.55s cubic-bezier(0.22, 1.2, 0.36, 1);
  background: #000;
}
@keyframes ad-pop-in {
  from { opacity: 0; transform: scale(0.82) translateY(30px); }
  to   { opacity: 1; transform: scale(1) translateY(0); }
}

/* ---------- Image ---------- */
.ad-img-link { display: block; position: relative; z-index: 1; }
.ad-img { width: 100%; display: block; }

/* ---------- Shine sweep ---------- */
.ad-shine {
  position: absolute;
  top: 0; left: -130%;
  width: 60%; height: 100%;
  z-index: 2;
  background: linear-gradient(105deg, transparent 0%, rgba(255, 255, 255, 0.4) 50%, transparent 100%);
  transform: skewX(-18deg);
  animation: ad-sweep 4s ease-in-out infinite;
  pointer-events: none;
}
@keyframes ad-sweep {
  0%   { left: -130%; }
  45%  { left: 150%; }
  100% { left: 150%; }
}

/* ---------- Badge ---------- */
.ad-badge {
  position: absolute;
  top: 18px; left: 18px;
  z-index: 4;
  background: var(--gold);
  color: #fff;
  font-weight: 600;
  font-size: 0.88rem;
  padding: 10px 22px;
  border-radius: 50px;
  box-shadow: 0 8px 22px rgba(201, 162, 75, 0.55);
  animation: ad-badge-pulse 2.2s ease-in-out infinite;
}
@keyframes ad-badge-pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.06); }
}

/* ---------- ✕ close button ---------- */
.ad-close {
  position: absolute;
  top: 14px; right: 14px;
  z-index: 5;
  width: 42px; height: 42px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  font-size: 1.1rem;
  display: grid;
  place-items: center;
  border: 1px solid rgba(255, 255, 255, 0.35);
  transition: all 0.3s ease;
}
.ad-close:hover { background: var(--gold); border-color: var(--gold); transform: rotate(90deg); }

/* ---------- Actions ---------- */
.ad-actions {
  position: absolute;
  bottom: 0; left: 0; right: 0;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  flex-wrap: wrap;
  padding: 18px 22px;
  background: linear-gradient(transparent, rgba(4, 16, 12, 0.85));
}
.ad-actions .btn { padding: 12px 26px; font-size: 0.88rem; }

.ad-skip {
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.85rem;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 50px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  transition: all 0.3s ease;
}
.ad-skip:hover { background: rgba(255, 255, 255, 0.15); color: #fff; }

/* ---------- Responsive ---------- */
@media (max-width: 600px) {
  .ad-overlay { padding: 14px; }
  .ad-badge { font-size: 0.72rem; padding: 7px 14px; top: 12px; left: 12px; }
  .ad-close { width: 36px; height: 36px; }
  .ad-actions { padding: 12px 14px; }
  .ad-actions .btn { padding: 10px 18px; font-size: 0.8rem; }
  /* ✅ sparkles now STAY VISIBLE on mobile too */
}
`, "",{"version":3,"sources":["webpack://./src/styles/WelcomeAd.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,6FAA6F;EAC7F,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;AAClB;AACA,wBAAwB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;;AAEhE,gEAAgE;AAChE,eAAe,kBAAkB,EAAE,QAAQ,EAAE,oBAAoB,EAAE,UAAU,EAAE;AAC/E,uBAAuB,UAAU,EAAE,IAAI,yCAAyC;;AAEhF;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0GAA0G;EAC1G,UAAU;EACV,oDAAoD,IAAI,qBAAqB;EAC7E,0CAA0C;AAC5C;AACA;EACE,6BAA6B;EAC7B,oDAAoD;AACtD;;AAEA;EACE,OAAO,UAAU,EAAE,kCAAkC,EAAE;EACvD,OAAO,UAAU,EAAE,oCAAoC,EAAE,IAAI,qBAAqB;EAClF,OAAO,UAAU,EAAE,oCAAoC,EAAE;AAC3D;;AAEA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,6EAA6E;EAC7E,2DAA2D;EAC3D,gBAAgB;AAClB;AACA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA,gCAAgC;AAChC,eAAe,cAAc,EAAE,kBAAkB,EAAE,UAAU,EAAE;AAC/D,UAAU,WAAW,EAAE,cAAc,EAAE;;AAEvC,sCAAsC;AACtC;EACE,kBAAkB;EAClB,MAAM,EAAE,WAAW;EACnB,UAAU,EAAE,YAAY;EACxB,UAAU;EACV,mGAAmG;EACnG,wBAAwB;EACxB,2CAA2C;EAC3C,oBAAoB;AACtB;AACA;EACE,OAAO,WAAW,EAAE;EACpB,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,SAAS,EAAE,UAAU;EACrB,UAAU;EACV,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,+CAA+C;EAC/C,mDAAmD;AACrD;AACA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,sBAAsB,EAAE;AAChC;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,SAAS,EAAE,WAAW;EACtB,UAAU;EACV,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,yBAAyB;AAC3B;AACA,kBAAkB,uBAAuB,EAAE,yBAAyB,EAAE,wBAAwB,EAAE;;AAEhG,kCAAkC;AAClC;EACE,kBAAkB;EAClB,SAAS,EAAE,OAAO,EAAE,QAAQ;EAC5B,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,+DAA+D;AACjE;AACA,mBAAmB,kBAAkB,EAAE,kBAAkB,EAAE;;AAE3D;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,yBAAyB;AAC3B;AACA,iBAAiB,qCAAqC,EAAE,WAAW,EAAE;;AAErE,qCAAqC;AACrC;EACE,cAAc,aAAa,EAAE;EAC7B,YAAY,kBAAkB,EAAE,iBAAiB,EAAE,SAAS,EAAE,UAAU,EAAE;EAC1E,YAAY,WAAW,EAAE,YAAY,EAAE;EACvC,cAAc,kBAAkB,EAAE;EAClC,mBAAmB,kBAAkB,EAAE,iBAAiB,EAAE;EAC1D,8CAA8C;AAChD","sourcesContent":["/* ---------- Full-screen overlay ---------- */\n.ad-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 5000;\n  background: radial-gradient(ellipse at center, rgba(14, 59, 46, 0.85), rgba(4, 16, 12, 0.95));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  animation: ad-fade-in 0.4s ease;\n  overflow: hidden;\n}\n@keyframes ad-fade-in { from { opacity: 0; } to { opacity: 1; } }\n\n/* ---------- ✨ Sparkle layers (background + image) ---------- */\n.ad-sparkles { position: absolute; inset: 0; pointer-events: none; z-index: 1; }\n.ad-box .ad-sparkles { z-index: 3; }   /* layer above the image inside the box */\n\n.sparkle {\n  position: absolute;\n  background: #fff;\n  clip-path: polygon(50% 0%, 61% 35%, 98% 36%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 36%, 39% 35%);\n  opacity: 0;\n  filter: drop-shadow(0 0 10px rgba(255, 255, 255, 1));   /* 👈 stronger glow */\n  animation: ad-twinkle ease-in-out infinite;\n}\n.sparkle.gold {\n  background: var(--gold-light);\n  filter: drop-shadow(0 0 12px rgba(230, 205, 143, 1));\n}\n\n@keyframes ad-twinkle {\n  0%   { opacity: 0; transform: scale(0.2) rotate(0deg); }\n  50%  { opacity: 1; transform: scale(1.15) rotate(90deg); }   /* 👈 brighter peak */\n  100% { opacity: 0; transform: scale(0.2) rotate(180deg); }\n}\n\n/* ---------- Ad box (above background sparkles) ---------- */\n.ad-box {\n  position: relative;\n  z-index: 2;\n  width: min(760px, 94%);\n  max-height: 92vh;\n  border-radius: 18px;\n  overflow: hidden;\n  box-shadow: 0 30px 90px rgba(0, 0, 0, 0.6), 0 0 60px rgba(201, 162, 75, 0.25);\n  animation: ad-pop-in 0.55s cubic-bezier(0.22, 1.2, 0.36, 1);\n  background: #000;\n}\n@keyframes ad-pop-in {\n  from { opacity: 0; transform: scale(0.82) translateY(30px); }\n  to   { opacity: 1; transform: scale(1) translateY(0); }\n}\n\n/* ---------- Image ---------- */\n.ad-img-link { display: block; position: relative; z-index: 1; }\n.ad-img { width: 100%; display: block; }\n\n/* ---------- Shine sweep ---------- */\n.ad-shine {\n  position: absolute;\n  top: 0; left: -130%;\n  width: 60%; height: 100%;\n  z-index: 2;\n  background: linear-gradient(105deg, transparent 0%, rgba(255, 255, 255, 0.4) 50%, transparent 100%);\n  transform: skewX(-18deg);\n  animation: ad-sweep 4s ease-in-out infinite;\n  pointer-events: none;\n}\n@keyframes ad-sweep {\n  0%   { left: -130%; }\n  45%  { left: 150%; }\n  100% { left: 150%; }\n}\n\n/* ---------- Badge ---------- */\n.ad-badge {\n  position: absolute;\n  top: 18px; left: 18px;\n  z-index: 4;\n  background: var(--gold);\n  color: #fff;\n  font-weight: 600;\n  font-size: 0.88rem;\n  padding: 10px 22px;\n  border-radius: 50px;\n  box-shadow: 0 8px 22px rgba(201, 162, 75, 0.55);\n  animation: ad-badge-pulse 2.2s ease-in-out infinite;\n}\n@keyframes ad-badge-pulse {\n  0%, 100% { transform: scale(1); }\n  50% { transform: scale(1.06); }\n}\n\n/* ---------- ✕ close button ---------- */\n.ad-close {\n  position: absolute;\n  top: 14px; right: 14px;\n  z-index: 5;\n  width: 42px; height: 42px;\n  border-radius: 50%;\n  background: rgba(0, 0, 0, 0.55);\n  color: #fff;\n  font-size: 1.1rem;\n  display: grid;\n  place-items: center;\n  border: 1px solid rgba(255, 255, 255, 0.35);\n  transition: all 0.3s ease;\n}\n.ad-close:hover { background: var(--gold); border-color: var(--gold); transform: rotate(90deg); }\n\n/* ---------- Actions ---------- */\n.ad-actions {\n  position: absolute;\n  bottom: 0; left: 0; right: 0;\n  z-index: 4;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  flex-wrap: wrap;\n  padding: 18px 22px;\n  background: linear-gradient(transparent, rgba(4, 16, 12, 0.85));\n}\n.ad-actions .btn { padding: 12px 26px; font-size: 0.88rem; }\n\n.ad-skip {\n  color: rgba(255, 255, 255, 0.85);\n  font-size: 0.85rem;\n  font-weight: 500;\n  padding: 8px 16px;\n  border-radius: 50px;\n  border: 1px solid rgba(255, 255, 255, 0.35);\n  transition: all 0.3s ease;\n}\n.ad-skip:hover { background: rgba(255, 255, 255, 0.15); color: #fff; }\n\n/* ---------- Responsive ---------- */\n@media (max-width: 600px) {\n  .ad-overlay { padding: 14px; }\n  .ad-badge { font-size: 0.72rem; padding: 7px 14px; top: 12px; left: 12px; }\n  .ad-close { width: 36px; height: 36px; }\n  .ad-actions { padding: 12px 14px; }\n  .ad-actions .btn { padding: 10px 18px; font-size: 0.8rem; }\n  /* ✅ sparkles now STAY VISIBLE on mobile too */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
